<template>
  <div>
    <base-header class="pb-8 pt-3">
      <!-- Card stats -->
      <b-row>
        <b-col md="3"> </b-col>
      </b-row>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <b-card class="shadow" no-body>
            <b-card-body>
              <b-row>
                <b-form-group class="col-2">
                  <b-form-select
                    v-model="filter.anio"
                    size="sm"
                    class="form-control-solid"
                    placeholder="Año"
                    :disabled="working"
                  >
                    <b-form-select-option value="2021"
                      >2021</b-form-select-option
                    >
                    <b-form-select-option value="2022"
                      >2022</b-form-select-option
                    >
                    <b-form-select-option value="2023"
                      >2023</b-form-select-option
                    >
                    <b-form-select-option value="2024"
                      >2024</b-form-select-option
                    >
                    <b-form-select-option value="2025"
                      >2025</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
                <b-form-group class="col-2">
                  <b-form-select
                    v-model="filter.mes"
                    size="sm"
                    class="form-control-solid"
                    placeholder="Mes"
                    :disabled="working"
                  >
                    <b-form-select-option value="1">Enero</b-form-select-option>
                    <b-form-select-option value="2"
                      >Febrero</b-form-select-option
                    >
                    <b-form-select-option value="3">Marzo</b-form-select-option>
                    <b-form-select-option value="4">Abril</b-form-select-option>
                    <b-form-select-option value="5">Mayo</b-form-select-option>
                    <b-form-select-option value="6">Junio</b-form-select-option>
                    <b-form-select-option value="7">Julio</b-form-select-option>
                    <b-form-select-option value="8"
                      >Agosto</b-form-select-option
                    >
                    <b-form-select-option value="9"
                      >Septiembre</b-form-select-option
                    >
                    <b-form-select-option value="10"
                      >Octubre</b-form-select-option
                    >
                    <b-form-select-option value="11"
                      >Noviembre</b-form-select-option
                    >
                    <b-form-select-option value="12"
                      >Diciembre</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
                <b-form-group>
                  <b-button
                    @click="getFind()"
                    :disabled="working"
                    variant="primary"
                    size="sm"
                    >Buscar</b-button
                  >
                </b-form-group>
              </b-row>
              <div v-if="error" class="alert alert-danger">
                {{ error.errors || error }}
              </div>
              <div class="table-responsive">
                <table
                  class="getting table align-items-center table-flush table-sm table-hover mb-4"
                >
                  <thead class="thead-light">
                    <tr
                      class="fw-bold fs-7 text-gray-500 border-bottom border-gray-200"
                    >
                      <th class="min-w-100px py-1">Sucursal</th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                    <tr
                      class="fw-bold fs-7 text-gray-500 border-bottom border-gray-200"
                    >
                      <th class="text-center py-1">Id</th>
                      <th class="text-center py-1">Tickets</th>
                      <th class="text-center py-1">Total</th>
                      <th class="text-center py-1">Fecha</th>
                      <th class="text-center py-1">Status</th>
                      <th class="text-center py-1">Met. Pago</th>
                      <th class="text-center py-1">Saldo</th>
                      <th class="text-center py-1">Folio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, kr) in rows">
                      <tr
                        v-if="item.factura_global"
                        :key="kr"
                        class="bg-translucent-white"
                      >
                        <td colspan="7" class="py-0">
                          {{ item.nombre }} ({{ item.id }})
                        </td>
                        <td>
                          <div class="d-flex justify-content-end flex-shrink-0">
                            <button
                              v-if="!item.venta_global.length"
                              @click="sincronizarSucursal(item.id)"
                              :disabled="working"
                              class="btn btn-outline-warning btn-sm"
                            >
                              Sincronizar
                            </button>
                            <button
                              @click="getTotales(item.id, params, item.nombre)"
                              :disabled="working"
                              class="btn btn-outline-primary btn-sm"
                            >
                              <i class="fas fa-search-dollar"></i> Totales
                            </button>
                          </div>
                        </td>
                      </tr>
                      <template v-if="item.venta_global.length">
                        <tr
                          v-for="factura in item.venta_global"
                          :key="factura.id"
                        >
                          <td class="text-right">{{ factura.id }}</td>
                          <td class="text-right">
                            <i class="fas fa-ticket-alt text-info"></i>
                            {{ factura.tickets | formatNumberInteger }}
                          </td>
                          <td class="text-right">
                            <i class="fas fa-dollar-sign text-info"></i>
                            {{ factura.total | formatNumberDecimal }}
                          </td>
                          <td class="text-center">
                            <input
                              v-if="!factura.folio"
                              v-model="factura.fecha"
                              type="date"
                              class="form-control form-control-alternative form-control-solid form-control-sm w-auto mb-1"
                            />
                            <select
                              v-if="!factura.folio"
                              v-model="factura.codmetodopago"
                              name="codmetodopago"
                              class="form-control form-control-alternative form-control-solid form-control-sm w-auto mb-1"
                            >
                              <option value="PUE" selected>Automático</option>
                              <option value="PUE">
                                PUE - Pago de Una Sola Exhibición
                              </option>
                              <option value="PPD">
                                PPD - Pago en Parcialidades o Diferido
                              </option>
                            </select>
                            <select
                              v-if="!factura.folio"
                              v-model="factura.codformapago"
                              name="codformapago"
                              class="form-control form-control-alternative form-control-solid form-control-sm w-auto mb-1"
                            >
                              <option value="0" selected>Automático</option>
                              <option value="01">01 - Efectivo</option>
                              <option value="02">02 - Cheque</option>
                              <option value="03">
                                03 - Transferencia electrónica de fondos
                              </option>
                              <option value="04">
                                04 - Tarjeta de crédito
                              </option>
                              <option value="05">28 - Tarjeta de débito</option>
                              <option value="99">99 - Por definir</option>
                            </select>
                            <span v-if="factura.folio">{{
                              factura.fecha
                            }}</span>

                            <button
                              v-if="!factura.folio"
                              :disabled="working"
                              @click="
                                timbrarGlobal(
                                  factura.id,
                                  factura.fecha,
                                  factura.codformapago,
                                  factura.codmetodopago
                                )
                              "
                              class="btn btn-sm btn-icon btn-primary ml-auto"
                            >
                              <i class="fas fa-bell"></i>
                            </button>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="!factura.cancel && !factura.replace"
                              class=""
                              >Vigente</span
                            >
                            <span
                              v-if="!factura.cancel && factura.replace"
                              class="badge badge-warning"
                              >Remplazo en proceso ({{ factura.replace }})</span
                            >
                            <span
                              v-if="factura.cancel && factura.replace"
                              class="text-red"
                              >Cancelado por remplazo ({{
                                factura.replace
                              }})</span
                            >

                            <!-- {{ factura }} -->
                          </td>
                          <td class="text-center">
                            <TagMethodPayment
                              :codmetodopago="factura.codmetodopago"
                              class=""
                            />
                          </td>
                          <td class="text-center">
                            <ButtonAddPayment
                              :total="factura.total"
                              v-if="factura.codmetodopago == 'PPD'"
                              :uuid="factura.folio"
                            />
                          </td>
                          <td class="text-right">
                            <template v-if="factura.folio">{{
                              factura.folio
                            }}</template>
                            <b-button
                              v-if="factura.folio"
                              :disabled="working"
                              :href="`${$backend}/api/facturacion/descargar/${factura.folio}`"
                              variant="outline-success"
                              size="sm"
                              class="text-primary ml-2"
                              target="_blank"
                              download
                            >
                              <i class="fas fa-download mr-1"></i>
                              ZIP
                            </b-button>
                            <b-button
                              v-if="item.venta_global.length"
                              variant="outline-success"
                              size="sm"
                              @click="modalActions(item, factura)"
                              class="text-primary mr-1"
                            >
                              <i class="c-pointer fas fa-info"></i>
                            </b-button>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </table>
              </div>

              <!-- <table
                class="getting table align-items-center table-flush table-sm table-hover"
              >
                <thead class="thead-light">
                  <tr
                    class="fw-bold fs-7 text-gray-500 border-bottom border-gray-200 py-4"
                  >
                    <th class="min-w-100px">Id</th>
                    <th class="min-w-100px">Sucursal</th>
                    <th class="min-w-100px p-0">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th class="text-center">Id</th>
                            <th class="text-center">Tickets</th>
                            <th class="text-center">Total</th>
                            <th class="text-center">Fecha</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Folio</th>
                          </tr>
                        </thead>
                      </table>
                    </th>
                    <th class="min-w-100px text-center">Herramientas</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, kr) in rows">
                    <tr v-if="item.factura_global" :key="kr" class="">
                      <td>{{ item.id }}</td>
                      <td>{{ item.nombre }}</td>
                      <td class="p-0">
                        <template v-if="item.venta_global.length">
                          <table class="table table-sm">
                            <tr
                              v-for="factura in item.venta_global"
                              :class="{ 'bg-light': factura.cancel }"
                              :key="factura.id"
                            >
                              <td class="text-right">{{ factura.id }}</td>
                              <td class="text-right">
                                <i class="fas fa-ticket-alt text-info"></i>
                                {{ factura.tickets | formatNumberInteger }}
                              </td>
                              <td class="text-right">
                                <i class="fas fa-dollar-sign text-info"></i>
                                {{ factura.total | formatNumberDecimal }}
                              </td>
                              <td class="d-flex flex-column">
                                <input
                                  v-if="!factura.folio"
                                  v-model="factura.fecha"
                                  type="date"
                                  class="form-control form-control-alternative form-control-solid form-control-sm w-auto mb-1"
                                />
                                <select
                                  v-if="!factura.folio"
                                  v-model="factura.codmetodopago"
                                  name="codmetodopago"
                                  class="form-control form-control-alternative form-control-solid form-control-sm w-auto mb-1"
                                >
                                  <option value="PUE" selected>
                                    Automático
                                  </option>
                                  <option value="PUE">
                                    PUE - Pago de Una Sola Exhibición
                                  </option>
                                  <option value="PPD">
                                    PPD - Pago en Parcialidades o Diferido
                                  </option>
                                </select>
                                <select
                                  v-if="!factura.folio"
                                  v-model="factura.codformapago"
                                  name="codformapago"
                                  class="form-control form-control-alternative form-control-solid form-control-sm w-auto mb-1"
                                >
                                  <option value="0" selected>Automático</option>
                                  <option value="01">01 - Efectivo</option>
                                  <option value="02">02 - Cheque</option>
                                  <option value="03">
                                    03 - Transferencia electrónica de fondos
                                  </option>
                                  <option value="04">
                                    04 - Tarjeta de crédito
                                  </option>
                                  <option value="05">
                                    28 - Tarjeta de débito
                                  </option>
                                  <option value="99">99 - Por definir</option>
                                </select>
                                <span v-if="factura.folio">{{
                                  factura.fecha
                                }}</span>

                                <button
                                  v-if="!factura.folio"
                                  :disabled="working"
                                  @click="
                                    timbrarGlobal(
                                      factura.id,
                                      factura.fecha,
                                      factura.codformapago,
                                      factura.codmetodopago
                                    )
                                  "
                                  class="btn btn-sm btn-icon btn-primary ml-auto"
                                >
                                  <i class="fas fa-bell"></i>
                                </button>
                              </td>
                              <td class="text-center">
                                <span
                                  v-if="!factura.cancel && !factura.replace"
                                  class="badge badge-success"
                                  >Vigente</span
                                >
                                <span
                                  v-if="!factura.cancel && factura.replace"
                                  class="badge badge-warning"
                                  >Remplazo en proceso ({{
                                    factura.replace
                                  }})</span
                                >
                                <span
                                  v-if="factura.cancel && factura.replace"
                                  class="badge badge-danger"
                                  >Cancelado por remplazo ({{
                                    factura.replace
                                  }})</span
                                >

                              </td>
                              <td>
                                <TagMethodPayment
                                  :codmetodopago="factura.codmetodopago"
                                  class="badge badge-secondary"
                                />
                              </td>
                              <td class="text-right">
                                <template v-if="factura.folio">{{
                                  factura.folio
                                }}</template>
                                <b-button
                                  v-if="factura.folio"
                                  :disabled="working"
                                  :href="`${$backend}/api/facturacion/descargar/${factura.folio}`"
                                  variant="info"
                                  size="sm"
                                  class="text-primary ml-2"
                                  target="_blank"
                                  download
                                >
                                  <i class="fas fa-download mr-1"></i>
                                  ZIP
                                </b-button>
                                <b-button
                                  v-if="item.venta_global.length"
                                  variant="info"
                                  size="sm"
                                  @click="modalActions(item, factura)"
                                  class="mr-1"
                                >
                                  <i class="c-pointer fas fa-info"></i>
                                </b-button>
                              </td>
                            </tr>
                          </table>
                        </template>
                      </td>
                      <td>
                        <div class="d-flex justify-content-end flex-shrink-0">
                          <button
                            v-if="!item.venta_global.length"
                            @click="sincronizarSucursal(item.id)"
                            :disabled="working"
                            class="btn btn-outline-warning btn-sm"
                          >
                            Sincronizar
                          </button>
                          <button
                            @click="getTotales(item.id, params, item.nombre)"
                            :disabled="working"
                            class="btn btn-outline-primary btn-sm"
                          >
                            <i class="fas fa-search-dollar"></i> Totales
                          </button>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table> -->
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      ref="modal-cfdi-acciones"
      hide-footer
      title="Acciones"
      body-class="border-top"
      header-class="py-2 align-items-baseline"
      size="lg"
    >
      <template #modal-title>
        <h3>Acciones</h3>
      </template>
      <div v-if="modal.cfdi">
        {{ modal.cfdi }}
        <p class="mb-0 small">
          Serie: <strong>{{ modal.cfdi.serie }}</strong>
        </p>
        <p class="mb-0 small">
          Emisor: <strong>{{ modal.branch.razon_social }}</strong>
        </p>
        <p class="mb-0 small">
          Receptor: <strong>{{ modal.cfdi.receptor }}</strong>
        </p>
        <p class="mb-0 small">
          UUID: <strong>{{ modal.cfdi.uuid }}</strong>
        </p>
        <p class="mb-0 small">
          Fecha Timbrado: <strong>{{ modal.cfdi.fechaTimbrado }}</strong>
        </p>
        <p class="mb-0 small">
          Estatus:
          <span v-if="!modal.cfdi.cancel" class="badge badge-success"
            >Vigente</span
          >
          <span v-if="modal.cfdi.cancel" class="badge badge-danger"
            >Cancelado</span
          >
        </p>
      </div>

      <div class="mt-2">
        <!-- {{ cfdi_detail }} -->
        <b-button
          v-if="cfdi_detail"
          :href="`${$backend}/api/facturacion/cfdi/${cfdi_detail.uuid}/recuperar-pdf`"
          variant="info"
          size="sm"
          class="text-primary"
          target="_blank"
          download
        >
          <i class="fas fa-file-pdf mr-1"></i>PDF
        </b-button>
        <b-button
          v-if="cfdi_detail"
          :href="`${$backend}/api/facturacion/cfdi/${cfdi_detail.uuid}/recuperar-xml`"
          variant="info"
          size="sm"
          class="text-primary"
          target="_blank"
          download
        >
          <i class="fas fa-file-excel mr-1"></i>XML
        </b-button>
        <b-button
          v-if="cfdi_detail"
          :href="`${$backend}/api/facturacion/cfdi/${cfdi_detail.uuid}/recuperar-pdf-ticket`"
          variant="info"
          size="sm"
          class="text-primary"
          target="_blank"
          download
        >
          <i class="fas fa-file-pdf mr-1"></i>PDF Ticket
        </b-button>
        <b-button
          v-if="cfdi_detail"
          :href="`${$backend}/api/facturacion/descargar/${cfdi_detail.uuid}`"
          variant="info"
          size="sm"
          class="text-primary"
          target="_blank"
          download
        >
          <i class="fas fa-download mr-1"></i>Descargar ZIP
        </b-button>
        <b-button
          @click="sendEmail(cfdi.uuid)"
          class="btn btn-sm btn-info text-primary"
          ><i class="fas fa-paper-plane mr-1"></i>Enviar por Email</b-button
        >
        <hr class="my-2" />
      </div>
      <div v-if="!cfdi.cancel" class="d-flex justify-content-between">
        <!-- <b-btn variant="primary" size="sm" block disabled
        >Reenviar por Correo</b-btn
      > -->
        <!-- <b-btn variant="danger" size="sm" block disabled>Cancelar CFDI</b-btn> -->
        <button-delete
          v-if="
            !cancel.show &&
            modal.cfdi &&
            (session.user.administrador || session.user.supervisor)
          "
          @onDelete="cancelInit(modal.cfdi.uuid)"
          :cancel="modal.cfdi.cancel"
          label="Iniciar cancelación"
        />
        <div v-if="cancel.show" class="w-100">
          <div class="d-flex justify-content-between">
            <h5>Cancelar comprobante</h5>
            <i
              @click="cancel.show = false"
              class="fas fa-times-circle text-gray"
            ></i>
          </div>
          <div class="form-group mb-1">
            <label for="" class="small">Motivo Cancelación</label>
            <select
              v-model="cancel.motivo"
              class="form-control form-control-sm form-control-solid"
            >
              <option
                v-for="motivo in cancel.options"
                :key="motivo.clave"
                :value="motivo.clave"
              >
                {{ motivo.description }}
              </option>
            </select>
          </div>
          <div
            v-if="cancel.motivo && cancel.motivo != '02'"
            class="alert alert-warning font-italic py-1 small"
          >
            Para generar el cfdi de remplazo, primero libere los tickets
            asociados, genere su nueva factura y asocie el UUID.
          </div>
          <h6>Tickets relacionados al CFDI</h6>
          <table v-if="cancel.ventas" class="table table-info table-sm">
            <thead class="bg-info">
              <tr>
                <th class="py-0 text-center">Tickets Asociados</th>
                <th class="py-0 text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">{{ cancel.ventas.count }}</td>
                <td class="text-center">
                  <button-delete
                    v-if="cfdi.venta_global"
                    @onDelete="
                      ReleaseTickets(cfdi.venta_global[0].id, cfdi_detail.uuid)
                    "
                    :cancel="cfdi_detail.cancel"
                    label="Liberar Ticket"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="cancel.motivo != '02'" class="form-group mb-1">
            <label for="" class="small">UUID Relacionado</label>
            <input
              v-model="cancel.folioSustitucion"
              type="text"
              class="form-control form-control-sm form-control-solid"
            />
          </div>
          <button-delete
            v-if="cancel.motivo"
            @onDelete="cancelCfdi(modal.cfdi.uuid, cancel.motivo)"
            :cancel="modal.cfdi.cancel"
            class="mt-1"
            label="Cancelar Comprobante"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import ButtonDelete from "@/components/IDBRICS/tools/ButtonDelete";
import TagMethodPayment from "@/components/IDBRICS/cfdi/TagMethodPayment";
import ButtonAddPayment from "@/components/IDBRICS/cfdi/ButtonAddPayment";
// import FacturacionSyncNotifications from "../../components/IDBRICS/FacturacionSyncNotifications.vue";
export default {
  components: {
    ButtonDelete,
    TagMethodPayment,
    ButtonAddPayment,
  },
  data() {
    return {
      moment: moment,
      working: false,
      error: null,
      filter: {
        acumulado: true,
        comparar: true,
        anio: moment().format("YYYY"),
        mes: moment().subtract(1, "months").format("M"),
        // mes: 6,
      },
      params: null,
      fileds: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "nombre",
          label: "Sucursal",
          class: "text-right",
          sortable: true,
        },
        {
          key: "venta_global",
          label: "Venta Gloabl",
          class: "text-right",
          sortable: true,
        },
        {
          key: "venta_global",
          label: "Venta Gloabl",
          class: "text-right",
          sortable: true,
        },
        {
          key: "acciones",
          label: "ACCIONES",
          sortable: true,
        },
      ],
      rows: [],
      cfdi: {},
      cfdi_detail: null,
      cancel: {
        show: false,
        acuse: "",
        motivo: "",
        folioSustitucion: "",
        options: [
          {
            clave: "01",
            description: "Comprobante emitido con errores con relación.",
            help: "Cuando se cancela un CFDI para corregir errores en el mismo y se emite uno nuevo con los datos correctos.",
          },
          {
            clave: "02",
            description: "Comprobante emitido con errores sin relación.",
            help: "Cuando se cancela un CFDI con errores, pero no se emite un nuevo CFDI que lo sustituya.",
          },
          {
            clave: "03",
            description: "No se llevo a cabo la operación.",
            help: "",
          },
          {
            clave: "04",
            description:
              "Operación nominativa relacionada en una factura global",
            help: "Cuidado, al utilizar esta opción de comprobantes facturados globalmente.",
          },
        ],
        ventas: null,
      },
      modal: {
        show: false,
        branch: null,
        cfdi: null,
      },
    };
  },
  mounted() {
    this.getFind();
  },
  computed: {
    ...mapState(["session"]),
  },
  methods: {
    getFind(params = null) {
      this.working = true;
      this.error = null;
      this.rows = [];

      if (!params) {
        this.params = JSON.parse(JSON.stringify(this.filter));
      }

      this.$api
        .get("/facturacion/factura-global/sucursales", {
          params: this.filter,
        })
        .then((res) => {
          this.rows = res.data;
        })
        .catch((e) => (this.error = e.response.data))
        .then(() => {
          this.working = false;
        });
    },
    sincronizarSucursal(id) {
      this.working = true;
      this.error = null;

      this.$api
        .post(
          `/facturacion/factura-global/sucursales/${id}/sincronizar`,
          this.params
        )
        .then((response) => {
          this.getFind(this.params);
        })
        .catch((e) => {
          this.$notiflix.Notify.failure(
            e.response.data.errors || e.response.data
          );
          console.log(e);
          this.error = e.response.data;
        })
        .then(() => {
          this.working = false;
        });
    },
    getTotales(id, params, nombre) {
      this.working = true;
      this.error = null;

      this.$api
        .get(`/facturacion/factura-global/sucursales/${id}/resumen-totales`, {
          params: this.params,
        })
        .then((response) => {
          const options2 = { style: "decimal", currency: "USD" };
          const numberFormat2 = new Intl.NumberFormat("en-US", options2);

          console.log(response.data);
          this.$notify({
            timeout: 60000,
            type: "default",
            closeOnClick: false,
            horizontalAlign: "center",
            title: `Resumen Totales ${nombre}`,
            message: `<table class="table table-sm bg-white mt-2" style="min-width:400px">
            <tbody>
            <tr>
              <td class="py-1">Facturado Individual</td>
              <td class="py-1 text-right">${numberFormat2.format(
                response.data.resumen_cfdi_individual.tickets
              )}</td>
              <td class="py-1 text-right">${numberFormat2.format(
                response.data.resumen_cfdi_individual.total
              )}</td>
            </tr>
            <tr>
              <td>Facturado Global</td>
              <td class="text-right">${numberFormat2.format(
                response.data.resumen_cfdi_global.tickets
              )}</td>
              <td class="text-right">${numberFormat2.format(
                response.data.resumen_cfdi_global.total
              )}</td>
            </tr>
            <tr class="font-weight-700">
              <td>Facturado Total</td>
              <td class="text-right">${numberFormat2.format(
                response.data.resumen_cfdi_individual.tickets +
                  response.data.resumen_cfdi_global.tickets
              )}</td>
              <td class="text-right">${numberFormat2.format(
                response.data.resumen_cfdi_individual.total +
                  response.data.resumen_cfdi_global.total
              )}</td>
            </tr>
            <tr>
              <td colspan="3" class="p-0">
                <hr class="my-0">
              </td>
            </tr>
            <tr class="font-weight-700">
              <td>ICG</td>
              <td class="text-right">${numberFormat2.format(
                response.data.icg_resumen.tickets
              )}</td>
              <td class="text-right">${numberFormat2.format(
                response.data.icg_resumen.total
              )}</td>
            </tr>
            </tbody>
          </table>`,
          });
          // alert();
          // this.$notiflix.Report.info(
          //   "Resumen Ventas",

          // );
        })
        .catch((e) => {
          this.error = e.response.data;
          this.$notiflix.Notify.failure(
            e.response.data.errors || e.response.data
          );
        })
        .then(() => {
          this.working = false;
        });
    },
    timbrarGlobal(id, fecha, codformapago = 0, codmetodopago = "PUE") {
      this.working = true;
      this.error = null;

      this.params.fecha = fecha;
      this.params.codformapago = codformapago;
      this.params.codmetodopago = codmetodopago;

      this.$api
        .post(`/facturacion/factura-global/${id}/timbrar`, this.params)
        .then((response) => {
          console.log(response);
          // this.rows = res.data;
          this.getFind(this.params);
        })
        .catch((e) => {
          this.$notiflix.Notify.failure(
            e.response.data.errors || e.response.data
          );
          console.log(e);
          this.error = e.response.data;
        })
        .then(() => {
          this.working = false;
        });
    },
    async modalActions(item, factura) {
      this.modal.branch = null;
      this.modal.cfdi = null;
      this.cfdi_detail = null;
      // this.cfdi = item;
      this.modal.branch = item;
      this.modal.cfdi = factura;
      await this.fetchCfdi(factura.folio);
      this.$refs["modal-cfdi-acciones"].show();
    },
    async fetchCfdi(uuid) {
      try {
        const response = await this.$api.get(
          `/facturacion/cfdi/${uuid}/payments`
        );

        this.modal.cfdi = response.data;
      } catch (error) {
        this.$notiflix.Notify.failure(
          error.response.data.errors || error.response.data
        );
      }
    },
    async cancelInit(uuid) {
      try {
        this.working = false;

        const response = await this.$api.get(
          `/facturacion/cfdi-global/${uuid}/ventas`
        );

        this.cancel.ventas = response.data;

        this.cancel.show = true;
      } catch (error) {
        this.$notiflix.Notify.failure(
          error.response.data.errors || error.response.data
        );
      }
    },
    async ReleaseTickets(venta_id, uuid) {
      try {
        this.working = true;

        const response = await this.$api.delete(
          `/facturacion/cfdi-global/${uuid}/ventas`
        );

        this.cancelInit(uuid);

        this.getFind();

        this.$notiflix.Notify.success("Tickets Liberados");

        // this.$api
        //   .delete(`facturacion/cfdi/${uuid}/ventas/${venta_id}`)
        //   .then((response) => {
        //     this.$notiflix.Notify.success("Cancelación exitosa.");
        //   })
        //   .catch((e) => {
        //     this.$notiflix.Notify.failure(
        //       e.response.data.errors[0] || e.response.data
        //     );
        //   })
        //   .then(() => (this.working = false));
      } catch (e) {
        console.log(e.response.data.errors[0]);
        this.$notiflix.Notify.failure(
          e.response.data.errors[0] || e.response.data.errors || e.response.data
        );
      } finally {
        this.working = false;
      }
    },
    cancelCfdi(uuid, motivo) {
      this.working = true;

      this.$api
        .delete(`facturacion/cfdi/${uuid}/cancelar`, {
          data: {
            motivo,
            folioSustitucion: this.cancel.folioSustitucion,
            cfdiGlobal: true,
          },
        })
        .then((response) => {
          this.modal.cfdi.cancel = 1;
          this.cancel.acuse = response.data.acuse;
          this.$notiflix.Notify.success("Cancelación exitosa.");
        })
        .catch((e) => {
          this.$notiflix.Notify.failure(
            e.response.data.errors[0] || e.response.data
          );
        })
        .then(() => (this.working = false));
    },
  },

  filters: {
    formatNumberDecimal: function (value) {
      const options2 = {
        style: "decimal",
        currency: "USD",
        maximumFractionDigits: 2,
      };
      const numberFormat2 = new Intl.NumberFormat("en-US", options2);

      return numberFormat2.format(value);
    },
    formatNumberInteger: function (value) {
      const options2 = {
        style: "decimal",
        currency: "USD",
        maximumFractionDigits: 0,
      };
      const numberFormat2 = new Intl.NumberFormat("en-US", options2);

      return numberFormat2.format(value);
    },
  },
};
</script>
<style>
.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
